import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from './../../components/successMessage'
import FailedMessage from './../../components/FailedMessage'
import useApiUrls from "../../useApiUrls";

const AddMQTTSetting = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // Updated state to hold all required form data
  const [formData, setFormData] = useState({
    settingname: "",       // Changed from MQTTSettingname to match API
    settingtype: "",       // Added field for setting type
    remark: "",
    active: true,
    json: "{}"             // Added JSON field with default empty object
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in cookies");
      setMessage("Failed to add Json Setting. Missing authentication.");
      return;
    }

    try {
      const MQTTSettingInsert = getUrlByOperation("MQTTSettingInsert");
      
      // Convert active to boolean if it's a string
      const apiFormData = {
        ...formData,
        active: formData.active === "true" || formData.active === true,
      };
      
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/JsonSettingOperation/Insert',
        apiFormData,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      
      if (response.data && response.data.isresponse && response.data.responsestatus === "SUCCESS") {
        setMessage("MQTT Setting added successfully!");
        
        // Clear form
        setFormData({
          settingname: "",
          settingtype: "",
          remark: "",
          active: true,
          json: "{}"
        });
        
        setTimeout(() => {
          navigate("/mqttSetting");
        }, 3000);
      } else {
        setMessage(`Failed to add json Setting: ${response.data?.errormsg || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error adding MQTT Setting:", error);
      setMessage(`Failed to add Json Setting: ${error.response?.data?.errormsg || error.message || "Server error"}`);
    }
  };

  // Handle JSON input with validation
  const handleJsonChange = (e) => {
    const value = e.target.value;
    try {
      // Validate that the input is valid JSON
      JSON.parse(value);
      setFormData((prevData) => ({
        ...prevData,
        json: value,
      }));
    } catch (error) {
      // If not valid JSON, still update but will show validation error
      setFormData((prevData) => ({
        ...prevData,
        json: value,
      }));
    }
  };

  // Function to check if JSON is valid
  const isJsonValid = (jsonString) => {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (error) {
      return false;
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Add Json Setting</h1>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Json Setting</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Setting Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.settingname}
                                onChange={handleChange}
                                placeholder="Enter setting name..."
                                name="settingname"
                                required
                              />
                            </div>
                          </div>
                        <div className="col-sm-6">
  <div className="form-group">
    <label>Setting Type</label>
    <select
      className="form-control"
      value={formData.settingtype}
      onChange={handleChange}
      name="settingtype"
      required
    >
      <option value="">Select setting type...</option>
      <option value="MQTT setting">MQTT setting</option>
      <option value="Screen setting">Screen setting</option>
      <option value="Wifi setting">Wifi setting</option>
      <option value="Master setting">Master setting</option>
    </select>
  </div>
</div>
                        </div>
                        
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter description..."
                                name="remark"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>JSON Configuration</label>
                              <textarea
                                className={`form-control ${!isJsonValid(formData.json) && formData.json !== "{}" ? "is-invalid" : ""}`}
                                value={formData.json}
                                onChange={handleJsonChange}
                                placeholder="Enter JSON configuration..."
                                name="json"
                                rows="4"
                              ></textarea>
                              {!isJsonValid(formData.json) && formData.json !== "{}" && (
                                <div className="invalid-feedback">
                                  Please enter valid JSON format
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                            disabled={!isJsonValid(formData.json)}
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "MQTT Setting added successfully!" ? (
        <SuccessMessage message={message} />
      ) : message.startsWith("Failed to add Json Setting") ? (
        <FailedMessage message={message} />
      ) : null}
    </>
  );
};

export default AddMQTTSetting;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}